import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
import baseRatingDefaults from '../BaseRating/BaseRating.defaults'

export default {
  ...cloneDeep(baseDefaults),
  afterText: 'Customer reviews <strong>9.2</strong> / 10 - 981',
  rating: cloneDeep(baseRatingDefaults),
  textColor: 'var(--color-text)',
}
